import content from "./content";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-background-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-10 py-10 md:py-16">
        <div className="space-y-8 md:space-y-12">
          {content.map((section, i) => (
            <section key={i}>
              <h2
                className={
                  i === 0
                    ? "text-xl md:text-2xl font-bold text-secondary-900 mb-4 md:mb-6"
                    : "text-base md:text-lg font-semibold text-secondary-800 mb-3 md:mb-4 pb-2 border-b border-background-200"
                }
              >
                {section.heading}
              </h2>
              {section.paragraphs.map((p, j) => {
                const isBullet = /^[A-Z]\.\s|^[a-z]\)\s|^[-–•]/.test(p);
                return (
                  <p
                    key={j}
                    className={
                      isBullet
                        ? "text-sm text-secondary-600 leading-relaxed ml-4 sm:ml-5 md:ml-6 mb-1"
                        : "text-sm text-secondary-600 leading-relaxed mb-2 md:mb-3"
                    }
                  >
                    {p}
                  </p>
                );
              })}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
